// @ts-nocheck
 
 
 
/* eslint-disable react/self-closing-comp */
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
 
 
 
import { useDispatch } from 'react-redux';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import React, { Fragment, useEffect, useRef, useState , Suspense } from 'react'

//import "../../style.css";
import { useIntl } from 'react-intl';
import PaidIcon from '@mui/icons-material/Paid';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
const TableLimitPaginationFilter = ({ page, pageCount, limit, handlePrevious, handleNext, handleChangeLimit, rightContent,transactions }) => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const intl = useIntl();
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us' //	ar-eg
  return (
    <div className='pagination-limit-table-info-part'>
      {/* Left: Dropdown */}
      {transactions?.length > 0 ? <div style={{ margin: "0 10px" }}>
        {intl.formatMessage({ id: 'Show' })}
        <select className='show-select' onChange={(e) => handleChangeLimit(e.target.value)}>
          <option value="10" selected={limit == 10 ? true : false}>10</option>
          <option value="15" selected={limit == 15 ? true : false}>15</option>
          <option value="25" selected={limit == 25 ? true : false}>25</option>
          <option value="50" selected={limit == 50 ? true : false}>50</option>
          <option value="100" selected={limit == 100 ? true : false}>100</option>
          <option value="150" selected={limit == 150 ? true : false}>150</option>
        </select>
      </div> : <div style={{ margin: "20px" }}></div>}
      {/* Center: Pagination arrows and from-to info */}
      {transactions?.length > 0 && <div style={{ margin: "15px", direction: "ltr" }}>
        <button className='pageArrow' disabled={page === 1} onClick={handlePrevious}>
          <span >   <KeyboardArrowLeftIcon style={{ fontSize: "30px" }} /></span>
        </button>
        {currentLanguageCode == "en-us" ?
          <span style={{ margin: "15px", direction: "ltr" }}>
            {page}  <span className='show-span'><bdi style={{ margin: "10px" }}> {intl.formatMessage({ id: 'From' })} </bdi></span>  {pageCount} </span>
          : <span style={{ margin: "10px", direction: "ltr" }}>
            {pageCount}  <span className='show-span'><bdi style={{ margin: "10px" }}> {intl.formatMessage({ id: 'From' })} </bdi></span>  {page} </span>}

        <button className='pageArrow' disabled={page === pageCount} onClick={handleNext}>
          <span >   <KeyboardArrowRightIcon style={{ fontSize: "30px" }} /></span>
        </button>
      </div>}
      {/* Right: Filter or any additional controls */}
      <div style={{ margin: "6px 10px" }}>
        {rightContent}
      </div>
    </div>
  )

};

export { TableLimitPaginationFilter };
